import { render, staticRenderFns } from "./myBoard.vue?vue&type=template&id=bf25898c&scoped=true"
import script from "./myBoard.vue?vue&type=script&lang=js"
export * from "./myBoard.vue?vue&type=script&lang=js"
import style0 from "./myBoard.vue?vue&type=style&index=0&id=bf25898c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf25898c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf25898c')) {
      api.createRecord('bf25898c', component.options)
    } else {
      api.reload('bf25898c', component.options)
    }
    module.hot.accept("./myBoard.vue?vue&type=template&id=bf25898c&scoped=true", function () {
      api.rerender('bf25898c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/myBoard.vue"
export default component.exports